<template>
  <div class="concern-industry-news-list-content">
    <div v-if="showUnread" @click="onShowNewMessage" class="row unread-message">
      <img src="../../assets/img/arrow-up.svg" class="icon" alt="">
      <div class="unread-count">{{latestIndustryNewsData.length}}条新闻</div>
    </div>
    <div v-show="personCount > 0">
      <div class="filter-tag">
        <concern-theme-news-list-filter
          :news-list-filters="industryNewsListFilters"
          v-if="industryNewsListFilters"
          :selected-tags="industryFilters"
          class="filter-panel"
          @change="onIndustryFilterChange"
        ></concern-theme-news-list-filter>
      </div>
      <industry-news-list-filter-panel 
        :filters="industryFilters" 
        @change="onFilterPanelChange"
        v-if="industryFilters.industry.length || industryFilters.event.length || industryFilters.emotional.length"
      ></industry-news-list-filter-panel>
    </div>
    <div class="concern-industry-news-list-item" v-show="personCount > 0">
      <div v-loading="isLoading">
        <div v-infinite-scroll="loadMoreIndustry" infinite-scroll-disabled="industryBusy" infinite-scroll-distance="10">
          <person-news-list-item v-for="(item, index) in industryResultData" :key="index" :data="item"></person-news-list-item>
        </div>
      </div>
      <div class="loading" v-if="industryListData.length && industryResultData.length && totalCount>industryPageSize"><div class="loading-word">加载中...</div></div>
      <div class="loading" v-if="industryResultData.length && !industryListData.length || (totalCount>0 && totalCount<=industryPageSize)"><div class="loading-word">没有更多了</div></div>
      <div class="concern-companies-empty" v-if="showEmptyData && !isLoading && !totalCount">
        <img class="empty-img" src="../../assets/img/empty-img.svg" alt="">
        <div class="empty-word">
          <div>暂无数据</div>
        </div>
      </div>
    </div>
    <div class="concern-industry-news-list-item" v-if="!personCount">
      <div class="concern-companies-empty">
        <img class="empty-img" src="../../assets/img/empty-img.svg" alt="">
        <div class="empty-word">
          <div>尊敬的用户，您当前尚未关注任何人物，可以通过以下方式管理关注人物：</div>
          <div>1、点击“<span @click="manageConcerns" class="empty-word-btn">管理关注内容</span>”，添加想要关注的人物</div>
          <div>2、进入具体人物页面，通过点击左上角的“+加关注”按钮添加关注人物</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';
import ConcernThemeNewsListFilter from '@/components/concern/ConcernThemeNewsListFilter';
import IndustryNewsListFilterPanel from '@/components/news-monitor/IndustryNewsListFilterPanel';
import PersonNewsListItem from '@/components/news-monitor/PersonNewsListItem';

export default {
  data() {
    return {
      personName: '',
      showEmptyData: false,
      totalCount: 0,
      ShowIndustryFilter: true,
      scrollTopIndustryNewsTimer: null,
      latestIndustryNewsData: [],
      showUnread: false,
      industryNewsListDoc: null,
      isLoading: false,
      industryNewsTimer: null,
      username: '',
      industryPageSize: 20,
      options: [],
      industryNewsListFilters: null,
      industryFilters: {
        industry: [],
        event: [],
        emotional: []
      },
      industryId: [],
      eventId: [],
      emotionalId: [],
      filtersData: {
        industry: [],
        event: [],
        emotional: []
      },
      industryResultData: [],
      industryListData: [],
      earliestIndustryNewsId: -1,
      earliestIndustryDateNum: -1,
      latestIndustryDateNum: -1,
      industryBusy: false,
      industryNewsListTimer: null,
      dateRange: [],
      themeData: []
    };
  },
  props: {
    personCount: {
      type: Number,
      default: 0
    },
    dateRangeData: {
      type: Array
    },
    themeTagData: {
      type: Array
    },
    personNameData: {
      type: String
    }
  },
  watch: {
    personNameData(val) {
      this.getLatestMonitorIndustryNewsSetInterval(false);
      this.earliestIndustryNewsId = -1;
      this.earliestIndustryDateNum = -1;
      this.latestIndustryDateNum = -1;
      this.totalCount = 0;
      this.industryListData = [];
      this.industryResultData = [];
      this.personName = val;
      this.getFirstMonitorIndustryNewsList();
    },
    dateRangeData(val) {
      if (!val) {
        this.getLatestMonitorIndustryNewsSetInterval(false);
        this.earliestIndustryNewsId = -1;
        this.earliestIndustryDateNum = -1;
        this.latestIndustryDateNum = -1;
        this.totalCount = 0;
        this.industryListData = [];
        this.industryResultData = [];
        this.dateRange = [];
        this.getFirstMonitorIndustryNewsList();
      } else {
        this.getLatestMonitorIndustryNewsSetInterval(false);
        this.earliestIndustryNewsId = -1;
        this.earliestIndustryDateNum = -1;
        this.latestIndustryDateNum = -1;
        this.totalCount = 0;
        this.industryListData = [];
        this.industryResultData = [];
        this.dateRange = this.dateRangeData;
        this.getMonitorIndustryNewsList();
      }
    },
    themeTagData(val) {
      this.getLatestMonitorIndustryNewsSetInterval(false);
      this.industryFilters = {
        industry: [],
        event: [],
        emotional: []
      };
      this.industryId = [];
      this.eventId = [];
      this.emotionalId = [];
      this.filtersData = {
        industry: [],
        event: [],
        emotional: []
      };
      this.earliestIndustryNewsId = -1;
      this.earliestIndustryDateNum = -1;
      this.latestIndustryDateNum = -1;
      this.totalCount = 0;
      this.industryListData = [];
      this.industryResultData = [];
      this.themeData = val;
      this.getMonitorIndustryTag();
      this.getFirstMonitorIndustryNewsList();
    }
  },
  components: {
    ConcernThemeNewsListFilter,
    IndustryNewsListFilterPanel,
    PersonNewsListItem
  },
  methods: {
    manageConcerns() {
      this.$router.push({
        path: '/follow',
        query: {
          type: 'person'
        }
      });
    },
    onFilterPanelChange(res) {
      this.getLatestMonitorIndustryNewsSetInterval(false);
      this.industryFilters = res;
      /* eslint-disable */
      this.industryId = this.industryFilters.industry.map(item => {
        return item.id;
      });
      this.eventId = this.industryFilters.event.map(item => {
        return item.id;
      });
      this.emotionalId = this.industryFilters.emotional.map(item => {
        return item.id;
      });
      // eslint-disable-next-line
      this.filtersData = {
        industry: this.industryId,
        event: this.eventId,
        emotional: this.emotionalId
      };
      this.earliestIndustryNewsId = -1;
      this.earliestIndustryDateNum = -1;
      this.latestIndustryDateNum = -1;
      this.totalCount = 0;
      this.industryListData = [];
      this.industryResultData = [];
      this.getFirstMonitorIndustryNewsList();
    },
    onIndustryFilterChange(filters) {
      this.getLatestMonitorIndustryNewsSetInterval(false);
      this.industryFilters = filters;
      /* eslint-disable */
      this.industryId = this.industryFilters.industry.map(item => {
        return item.id;
      });
      this.eventId = this.industryFilters.event.map(item => {
        return item.id;
      });
      this.emotionalId = this.industryFilters.emotional.map(item => {
        return item.id;
      });
      this.filtersData = {
        industry: this.industryId,
        event: this.eventId,
        emotional: this.emotionalId
      };
      this.earliestIndustryNewsId = -1;
      this.earliestIndustryDateNum = -1;
      this.latestIndustryDateNum = -1;
      this.totalCount = 0;
      this.industryListData = [];
      this.industryResultData = [];
      this.getFirstMonitorIndustryNewsList();
    },
    onShowIndustryFilter() {
      this.ShowIndustryFilter = !this.ShowIndustryFilter;
    },
    getMonitorIndustryTag() {
      QuestionQuery.getMonitorThemeTagList(this.username).then(res => {
        this.options = res.map(item => {
          return {
            label: item.name,
            value: item.name
          };
        });
        this.options.unshift({ label: '全部', value: '全部' });
        const emotional = [
          {
            id: '正面',
            name: '正面'
          },
          {
            id: '负面',
            name: '负面'
          },
          {
            id: '中性',
            name: '中性'
          }
        ];
        /* eslint-disable */
        this.industryNewsListFilters = {
          event: res.event,
          emotional: emotional
        };
      });
    },
    loadMoreIndustry() {
      this.industryBusy = true;
      if (this.industryNewsTimer) {
        clearTimeout(this.industryNewsTimer);
      }
      if (this.industryListData.length) {
        this.industryNewsTimer = setTimeout(() => {
          this.getMonitorIndustryNewsList();
        }, 500);
      }
    },
    getLatestMonitorIndustryNewsList() {
      const params = {
        user: this.username,
        pageSize: 15,
        date: [],
        persons: [this.personName],
        personSentiments: this.filtersData.emotional,
        earliestNewsId: -1,
        earliestDateNum: -1,
        latestDateNum: this.latestIndustryDateNum
      };
      QuestionQuery.getMonitorPersonNewsList(params).then(
        res => {
          if (res.result.length) {
            this.latestIndustryDateNum = res.result[0].dateNum;
            if (this.industryNewsListDoc.scrollTop >= 0 && this.industryNewsListDoc.scrollTop <= 300) {
              this.showUnread = false;
              this.industryResultData.unshift(...res.result);
            } else {
              this.showUnread = true;
              this.latestIndustryNewsData = this.latestIndustryNewsData.concat(res.result);
            }
          }
        },
        () => {
          this.getLatestMonitorIndustryNewsSetInterval(false);
        }
      );
    },
    onShowNewMessage() {
      this.showUnread = false;
      if (this.latestIndustryNewsData.length >= 50) {
        this.industryResultData.unshift(...this.latestIndustryNewsData);
        this.latestIndustryNewsData = [];
        this.industryNewsListDoc.scrollTop = 0;
      } else {
        this.industryResultData.unshift(...this.latestIndustryNewsData);
        this.latestIndustryNewsData = [];
        this.scrollTopIndustryNewsTimer = setInterval(() => {
          if (this.industryNewsListDoc.scrollTop) {
            this.industryNewsListDoc.scrollTop = this.industryNewsListDoc.scrollTop - 200;
          } else if (!this.industryNewsListDoc.scrollTop || this.industryNewsListDoc.scrollTop < 0) {
            clearInterval(this.scrollTopIndustryNewsTimer);
          }
        }, 50);
      }
    },
    getMonitorIndustryNewsList() {
      const params = {
        user: this.username,
        pageSize: this.industryPageSize,
        persons: [this.personName],
        personSentiments: this.filtersData.emotional,
        earliestNewsId: this.earliestIndustryNewsId,
        earliestDateNum: this.earliestIndustryDateNum,
        latestDateNum: -1,
        date: []
      };
      this.isLoading = true;
      QuestionQuery.getMonitorPersonNewsList(params).then(res => {
        this.isLoading = false;
        this.industryListData = res.result;
        this.totalCount = res.totalCount;
        if (this.industryListData.length) {
          this.earliestIndustryNewsId = this.industryListData[this.industryListData.length - 1].newsId;
          this.earliestIndustryDateNum = this.industryListData[this.industryListData.length - 1].dateNum;
          this.industryResultData = this.industryResultData.concat(this.industryListData);
          this.industryBusy = false;
        } else {
          this.industryBusy = true;
        }
      });
    },
    getFirstMonitorIndustryNewsList() {
      const params = {
        user: this.username,
        pageSize: this.industryPageSize,
        persons: [this.personName],
        personSentiments: this.filtersData.emotional,
        earliestNewsId: this.earliestIndustryNewsId,
        earliestDateNum: this.earliestIndustryDateNum,
        latestDateNum: -1,
        date: []
      };
      this.isLoading = true;
      QuestionQuery.getMonitorPersonNewsList(params).then(res => {
        this.isLoading = false;
        this.industryListData = res.result;
        this.totalCount = res.totalCount;
        this.showEmptyData = res.totalCount === 0;
        if (this.industryListData.length) {
          this.latestIndustryDateNum = res.result[0].dateNum;
          this.earliestIndustryNewsId = this.industryListData[this.industryListData.length - 1].newsId;
          this.earliestIndustryDateNum = this.industryListData[this.industryListData.length - 1].dateNum;
          this.industryResultData = this.industryResultData.concat(this.industryListData);
          this.industryBusy = false;
        } else {
          this.industryBusy = true;
        }
        this.getLatestMonitorIndustryNewsSetInterval(true);
      });
    },
    getLatestMonitorIndustryNewsSetInterval(start) {
      if (this.industryNewsListTimer) {
        clearTimeout(this.industryNewsListTimer);
      }
      if (start) {
        this.industryNewsListTimer = setTimeout(() => {
          this.getLatestMonitorIndustryNewsList();
          this.getLatestMonitorIndustryNewsSetInterval(start);
        }, 1000 * 60);
      }
    }
  },
  async mounted() {
    this.industryNewsListDoc = document.documentElement;
    this.themeData = this.themeTagData;
    this.dateRange = this.dateRangeData;
    this.username = authService.getLoggedUserName();
    const personName = await QuestionQuery.getMonitorPersonNameList(this.username);
    if (personName.length) {
      this.personName = personName[0].person;
    }
    this.getMonitorIndustryTag();
    // this.getFirstMonitorIndustryNewsList();
  },
  beforeDestroy() {
    this.showUnread = false;
    this.getLatestMonitorIndustryNewsSetInterval(false);
    if (this.industryNewsListTimer) {
      clearInterval(this.industryNewsListTimer);
    }
  }
};
</script>

<style lang="scss" scoped>
.icon {
  width: 16px;
}
.loading {
  padding: 12px 0;
  margin: 0 auto;
  height: 10px;
  width: 772px;
  color: #666666;
  text-align: center;
}
.unread-message {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0 12px;
  height: 17px;
  background-color: #636772;
  border-radius: 2px;
  z-index: 1;
  cursor: pointer;
  .unread-count {
    margin-right: 4px;
    color: #ffffff;
    font-size: 12px;
    cursor: pointer;
  }
}
.concern-industry-news-list-item {
  min-height: 800px;
  .concern-companies-empty {
    position: relative;
    width: 100%;
    margin-top: 10px;
    height: 100%;
    background-color: #ffffff;
    .empty-img {
      position: absolute;
      top: 180px;
      left: 50%;
      transform: translateX(-50%);
    }
    .empty-word {
      position: absolute;
      top: 350px;
      left: 50%;
      transform: translateX(-50%);
      color: #747990;
      font-size: 14px;
      &-btn {
        color: #45a8cc;
        cursor: pointer;
      }
    }
  }
}
.concern-industry-news-list {
  // margin-top: 10px;
  background-color: #ffffff;
  width: 100%;
  .concern-industry-news-list-item {
    min-height: 800px;
    .concern-companies-empty {
      position: relative;
      width: 100%;
      margin-top: 10px;
      height: 100%;
      background-color: #ffffff;
      .empty-img {
        position: absolute;
        top: 180px;
        left: 50%;
        transform: translateX(-50%);
      }
      .empty-word {
        position: absolute;
        top: 350px;
        left: 50%;
        transform: translateX(-50%);
        color: #747990;
        font-size: 14px;
        &-btn {
          color: #45a8cc;
          cursor: pointer;
        }
      }
    }
  }
  .sn-date-picker {
    margin-right: 10px;
  }
  &-select {
    width: 100px;
  }
  &-filter-btn {
    margin-left: 10px;
    height: 26px;
    width: 128px;
    padding: 0;
    border-radius: 2px;
    border: none;
    font-size: 14px;
    color: #464d6c;
    background-color: #f7f8fc;
    font-weight: 400;
    &:hover {
      color: #464d6c;
      background-color: #eaeaed;
    }
    &:focus {
      color: #464d6c;
      background-color: #eaeaed;
    }
    &:active {
      color: #464d6c;
      background-color: #eaeaed;
    }
    &-img {
      margin-bottom: -3px;
    }
  }
  &-content {
    padding: 16px 24px 18px;
    background-color: #ffffff;
    .filter-tag {
      position: relative;
      width: 100%;
      background-color: #f7f8fc;
    }
  }
  .loading {
    padding: 12px 0;
    margin: 0 auto;
    height: 10px;
    width: 772px;
    color: #666666;
    text-align: center;
  }
}
</style>
